module.exports = __webpack_public_path__ + "static/media/cpp.b4dd4c5e.png";